import script from "./upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./upload.vue?vue&type=script&lang=ts&setup=true"

import "./upload.vue?vue&type=style&index=0&id=e40ac966&lang=scss&scoped=true"
import "./upload.vue?vue&type=style&index=1&id=e40ac966&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e40ac966"]])

export default __exports__